import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonService } from 'src/app/shared/common.service';
import { ToastService } from 'src/app/shared/toast.service';

interface TeamMember {
  name: string;
  title: string;
  description: string;
  imageUrl: string;
   showFullDescription?: boolean;
}

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutusComponent {
  videoUrl!: SafeResourceUrl;

   userForm!: FormGroup;
  isSubmitting = false;
  successMessage = '';
  errorMessage = '';

  teamMembers: TeamMember[] = [];

  plateformCards = [
    {
      img: '../../../assets/about/blogs.jpeg',
      head: 'Blog & Articles',
      para: 'Get expert insights, coaching strategies, and industry trends from top executive coaches.',
      button: 'Go to Blogs',
      route: '/blogs',
      isExternalLink: false, // This is an internal Angular route
      downloadFilename: ''   // Not applicable
    },
    {
    img: '../../../assets/about/E-book.jpeg',
    head: 'E-Books & Guides',
    para: 'Download free coaching guides, business-building strategies, and ICF certification roadmaps.',
    button: 'Download Free E-Book',
    route: '../../assets/coaching e-book.pdf', // <-- Likely correction
    isExternalLink: true,
    downloadFilename: 'coaching-e-book.pdf'
  },
    {
      img: '../../../assets/about/live sessions.jpeg',
      head: 'Webinars & Live Events',
      para: 'Join upcoming live training sessions and watch recordings of past events.',
      button: 'Join Free Live Webinar',
      route: '/live-session',
      isExternalLink: false, // This is an internal Angular route
      downloadFilename: ''   // Not applicable
    }
  ];

  constructor(private sanitizer: DomSanitizer, 
    private fb: FormBuilder,
    private commonService: CommonService,
    private toast: ToastService
  ) {
     this.userForm = this.fb.group({
  firstName: ['', Validators.required],
  lastName: ['', Validators.required],
  email: ['', [Validators.required, Validators.email]],
  message: ['', Validators.required]
});
  }

  ngOnInit(): void {
     const youtubeLink = 'https://www.youtube.com/embed/rL4zzMLGBCs';
     this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(youtubeLink);


     this.teamMembers = [
  {
    name: 'Lyssa deHart',
    title: 'Lyssa deHart, LICSW, MCC, BCC, EMCC, is a respected author, coaching educator, and "recovering therapist."',
    description: 'Lyssa is an ICF Master Certified Coach and sought-after coaching educator who blends neuroscience, psychology, and the ICF Core Competencies into practical, real-world coaching. She is the author of StoryJacking, The Reflective Coach, Light Up: The Science of Coaching with Metaphors, and the upcoming Sticky Outcomes. Through her exam prep programs and mentor coaching, she has helped thousands of coaches around the world deepen their presence, listening, and client-led partnership. As host of The Coaching Studio Podcast, Lyssa regularly interviews thought leaders across coaching and psychology, bringing fresh insight and practical wisdom to the global coaching community.',
    imageUrl: '../../../assets/instructors/Lyssa deHart.png',
    showFullDescription: false
  },
  {
    name: 'Jake Mannino',
    title: 'Helping humanity thrive through iconic leadership, adaptive momentum, and signal clarity.',
    description: 'Jake is a senior global sales and strategy leader who has helped drive more than $1B in revenue impact across technology, SaaS, and cybersecurity. At Microsoft, he co-led a record-breaking internal coaching initiative that reached over 12,000 employees and earned a Guinness World Record for scalable culture transformation. He is known for helping executives develop clarity, resilience, and strategic influence in fast-moving environments. Jake’s work sits at the intersection of leadership, AI, and human performance, guiding leaders to harness modern tools while strengthening their human edge. Jake is deeply committed to developing leaders who can communicate with precision, think strategically under pressure, and create momentum within their organizations.',
    imageUrl: '../../../assets/instructors/Jake.jpg',
    showFullDescription: false
  },
  {
    name: 'Rob Brunhild',
    title: 'Rob is a seasoned business executive with over 30 years experience working in Fortune 500 companies as well as high-growth environments.',
    description: 'In his coaching practice, Rob partners with individuals and teams to help them solve everyday challenges, maximize productivity, further strategic goals, and produce superior outcomes. Rob has extensive coaching experience as well as senior leadership roles in Enterprise Sales, Operations, and Delivery Management. He believes the value of the relationships one builds is as important as the products one creates, and that lasting connections with internal and external stakeholders drive productivity, innovation, and career success. Rob passionately adheres to the core value of “Being True” by engaging colleagues and customers with integrity, trust, and respect.',       
    imageUrl: '../../../assets/instructors/ROB.jpg',
    showFullDescription: false
  }
];

  }

   submitForm2() {
    if (this.userForm.invalid) return;

    this.isSubmitting = true;
    this.successMessage = '';
    this.errorMessage = '';

    const payload = this.userForm.value;

    this.commonService.sendContactMessage(payload).subscribe({
      next: (res) => {
        if (res.status === 1) {
          this.successMessage = res.message;
          this.toast.showSuccess(res.message)
          this.userForm.reset();
        } else {
          this.toast.showError('Something went wrong. Please try again.')
        }
        this.isSubmitting = false;
      },
      error: (err) => {
        console.error('Error:', err);
        this.errorMessage = 'Server error. Please try again later.';
        this.toast.showError('Server error. Please try again later.')
        this.isSubmitting = false;
      }
    });
  }
}
